import { types, actions } from './requests'
export const GETWORKER_TYPES = {
    ...types('GETWORKER'),
}
export const GETWORKER_ACTIONS = {
    ...actions('GETWORKER'),
}
